import { Controller } from "@hotwired/stimulus"

// Opens the browser's print dialog; the page's print styles do the rest.
export default class extends Controller {
  print() {
    window.print()
  }
}
